import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ConnectionState } from './classes/connection-state';
import { Socket } from './classes/socket';
import { SocketMethod } from './classes/socket-method';
import { ISocketRequest } from './interfaces/ISocketRequest';

/** 
 * Websocket wrapper providing an Observable of connection state and an Observable of messages received
 */
@Injectable({
  providedIn: 'root'
})
export class SocketService implements OnDestroy {
  private _socket: Socket | undefined

  private get Socket(): Socket {
    this._socket = this._socket ?? new Socket()
    return this._socket
  }

  constructor() { }

  ngOnDestroy(): void {
    this.Socket.cleanUp()
  }

  public get Messages(): Observable<any> {
    return this.Socket.Messages
  }

  public get FailedConnectionAttempts(): number {
    return this.Socket.FailedConnectionAttempts;
  }

  public get Connected(): boolean {
    return this.Socket.Connected
  }

  public get ConnectionState(): BehaviorSubject<ConnectionState> {
    return this.Socket.ConnectionState
  }

  public connect(url: string, token: string, provider: string): Observable<ConnectionState> {
    this.Socket.connect(url, token, provider)
    return this.Socket.ConnectionState
  } // connect()

  public disconnect(): void {
    this.Socket.disconnect()
  } // disconnect()

  public createRequest(action: SocketMethod, authId: string | null, payload: any, transactional: boolean = true): ISocketRequest {
    return this.Socket.createRequest(action, authId, payload, transactional)
  } // createRequest()

  public sendMessage(message: any): void {
    this.Socket.sendMessage(message)
  } // sendMessage()
}
